import Combobox from 'react-widgets/Combobox';
import {useIntl} from 'react-intl';
import {toimintaEnum} from '../static/toimintaEnum';

const getOptions = locale => {
  return toimintaEnum.map(toiminta => {
    return {value: toiminta.value, label: toiminta[`label_${locale}`]};
  });
};

const NewComboboxSearch = props => {
  const intl = useIntl();
  return (
    <div style={{maxWidth: '28.1rem', marginTop: '1rem', paddingBottom: '1rem', marginRight: '1rem'}}>
      <Combobox
        name="businessType"
        data={getOptions(intl.locale)}
        textField="label"
        inputProps={{type: 'search'}}
        value={props.value}
        placeholder={intl.formatMessage({
          id: 'combobox_placeholder',
          defaultMessage: 'Toiminta'
        })}
        casesensitive="false"
        minLength={1}
        filter="contains"
        onChange={props.onChange}
      />
    </div>
  );
};
export default NewComboboxSearch;
